import apiService from './api.service';

export interface CrmIntegrationData {
  id?: string;
  tenant_id?: string;
  project_id: string;
  project_name?: string;
  base_url?: string;
  phone_number_id?: string;
  default_phones?: string[];
  is_active?: boolean;
  api_token_masked?: string;
  created_at?: string;
  updated_at?: string;
}

export interface CrmProject {
  id: string;
  name: string;
}

export interface CrmPhoneNumber {
  id: string;
  number: string;
  name?: string;
}

class CrmIntegrationApi {
  async get(): Promise<{ success: boolean; data: CrmIntegrationData | null }> {
    return apiService.get('/v1/crm-integrations');
  }

  async save(data: {
    api_token?: string;
    project_id: string;
    project_name?: string;
    base_url?: string;
    phone_number_id?: string;
    default_phones?: string[];
  }): Promise<{ success: boolean; data: CrmIntegrationData }> {
    return apiService.post('/v1/crm-integrations', data);
  }

  async delete(): Promise<{ success: boolean; message: string }> {
    return apiService.delete('/v1/crm-integrations');
  }

  async testConnection(data: {
    api_token: string;
    base_url?: string;
  }): Promise<{ success: boolean; message: string }> {
    return apiService.post('/v1/crm-integrations/test', data);
  }

  async getProjects(apiToken: string, baseUrl?: string): Promise<{ success: boolean; data: CrmProject[] }> {
    const params: any = { api_token: apiToken };
    if (baseUrl) params.base_url = baseUrl;
    return apiService.get('/v1/crm-integrations/projects', { params });
  }

  async getPhoneNumbers(apiToken: string, projectId: string, baseUrl?: string): Promise<{ success: boolean; data: CrmPhoneNumber[] }> {
    const params: any = { api_token: apiToken, project_id: projectId };
    if (baseUrl) params.base_url = baseUrl;
    return apiService.get('/v1/crm-integrations/phone-numbers', { params });
  }

  async getMyProjects(): Promise<{ success: boolean; data: CrmProject[] }> {
    return apiService.get('/v1/crm-integrations/my-projects');
  }

  async getMyPhoneNumbers(): Promise<{ success: boolean; data: CrmPhoneNumber[] }> {
    return apiService.get('/v1/crm-integrations/my-phone-numbers');
  }
}

export default new CrmIntegrationApi();
